module.exports = __webpack_public_path__ + "img/shakeRedEnvelopes.c2f9093a.gif";